import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';

import LoadingSpinner from '../partials/LoadingSpinner';

import { purchaseOrderUpdateQuantity, purchaseOrderOverrideUnitCost, purchaseOrderOverrideLineTax, removeOrderLine } from '../../redux/actions/purchaseOrders';

const PurchaseOrderLine = ({ 
  payload,
  purchaseOrderLine,
  purchaseOrderLines,
  purchaseOrderType,
  quantityUpdate,
  overrideCost,
  overrideTax,
  remove,
  setModalProductId,
  setModalVariationId,
  setModalOptions,
  setModalProductName,
  setModalType,
  setModalAssignment,
  setShowAddSupplierAssignmentModal,
  activeSupplier,
  activeSuggestedPurchaseOrder,
  showSuggestionLevels,
  showUpdateExternal,
  settings,
  accountUnits, }) => {

  const [adjustedUnitCost, setAdjustedUnitCost] = useState(purchaseOrderLine.supplier_price);
  const [adjustedTax, setAdjustedTax] = useState(null);
  const [quantity, setQuantity] = useState(null);
  const [lineDetail, setLineDetail] = useState(null);
  const [suggestionStatus, setSuggestionStatus] = useState(null);

  useEffect(() => {
    let detail = purchaseOrderLines.lineDetails[purchaseOrderLine.productId + '/' + purchaseOrderLine.variationId];

    if(detail) {
      setLineDetail(detail);
      setAdjustedTax(detail.adjustedTax || '');
      setQuantity(detail.quantity);
      setAdjustedUnitCost(detail.adjustedUnitCost || purchaseOrderLine.supplier_price);
    }

    if(activeSuggestedPurchaseOrder && showSuggestionLevels) {
      let matchingLine = activeSuggestedPurchaseOrder.suggested_purchase_order_lines.suggested_purchase_order_lines.find( line => (parseInt(line.product_id) === parseInt(purchaseOrderLine.productId)) && (parseInt(line.variation_id) === parseInt(purchaseOrderLine.variationId)) )

      if(matchingLine) {
        if(matchingLine.is_low) {
          setSuggestionStatus('low');
        }

        if(matchingLine.is_critical) {
          setSuggestionStatus('critical');
        }
      }
    }
  }, [purchaseOrderLines]);

  const updateQuantity = () => {
    let value = event.target.value;
    let quantityInt = parseInt(value);
    if(quantityInt < 0) { quantityInt = 0; }

    setQuantity(quantityInt);
    quantityUpdate(payload, value, purchaseOrderLine.productId + '/' + purchaseOrderLine.variationId)
  }

  const overrideUnitCost = (e) => {
    let value = event.target.value;
    setAdjustedUnitCost(value);
    overrideCost(payload, value, purchaseOrderLine.productId + '/' + purchaseOrderLine.variationId)
  }

  const overrideUnitTax = (e) => {
    let value = event.target.value;
    setAdjustedTax(value);
    overrideTax(payload, value, purchaseOrderLine.productId + '/' + purchaseOrderLine.variationId)
  }

  const format = (value) => {
    return (accountUnits.currencyPrefix + (parseFloat(value) || 0).toFixed(parseInt(accountUnits.currencyPrecision)) + accountUnits.currencySuffix).replace('.', accountUnits.currencyDecimalSeparator);
  }

  const showAddSupplierAssignmentModal = (e) => {
    setModalProductId(purchaseOrderLine.productId);
    setModalVariationId(purchaseOrderLine.variationId);

    setModalOptions(purchaseOrderLine.options);
    setModalProductName(purchaseOrderLine.name);
    setModalType(purchaseOrderLine.variationId === null ? 'product' : 'variation');

    setShowAddSupplierAssignmentModal(true);
  }

  return(
    <div className={`a-card a-card--normal ${ (purchaseOrderType === 'direct' && activeSupplier) ? ( purchaseOrderLine.orderMatchingAssignment ? 'a-card--success' : 'a-card--warning' ) : '' }`}>
      <div className="a-card__paddings">
        <div className="has-hover sku-line">
          <h4>
            { purchaseOrderLine.name || purchaseOrderLine.productName }
            { suggestionStatus &&
              <>
                &nbsp;
                &nbsp;
                <span>{suggestionStatus}</span>
              </>
            }
            { purchaseOrderLine.is_external &&
              <>
                &nbsp;
                &nbsp;
                <span className="text-small muted">external</span>
                &nbsp;
                <button
                  className="btn btn-default"
                  onClick={(e, ) => showUpdateExternal(e, purchaseOrderLine.productId, (purchaseOrderLine.name || purchaseOrderLine.productName), purchaseOrderLine.supplier_price, purchaseOrderLine.supplier_sku)}
                >
                  <span className="svg-icon">
                    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18"><path d="M5.0355 15.7929 2.207 12.9645 1.5 16.5l3.5355-.7071z"/><path fill-rule="evenodd" clip-rule="evenodd" d="M12.8136.9437c.3906-.3905 1.0237-.3905 1.4143 0l2.8284 2.8284c.3905.3905.3905 1.0237 0 1.4142L5.5285 16.7141.2252 17.7748l1.0606-5.3033L12.8136.9437zm.7072 2.1213-9.8995 9.8995 1.4142 1.4142 9.8995-9.8995-1.4142-1.4142zM3.0071 15.1788l-.186-.186-.0464.2325.2324-.0465z"/></svg>
                  </span>
                  <span className="gwt-InlineLabel">Update</span>
                </button>
              </>
            }
          </h4>
          <div className="flex-container">
            <div className="left-15">
              { purchaseOrderLine.imageUrl && <img src={purchaseOrderLine.imageUrl} /> }
            </div>
            <div className="flex-1">
              <ul>
                { purchaseOrderLine.supplier_sku && <li><strong>Supplier SKU</strong>: <span className="inline-text-tag">{ purchaseOrderLine.supplier_sku }</span></li> }
                { purchaseOrderLine.sku && <li><strong>SKU</strong>: <span className="inline-text-tag">{ purchaseOrderLine.sku }</span></li> }
                { purchaseOrderLine.upc && <li><strong>UPC</strong>: <span className="inline-text-tag">{ purchaseOrderLine.upc }</span></li> }
                { purchaseOrderLine?.options && purchaseOrderLine?.options.map(option =>
                    <li>
                      <strong>{ option.name }</strong>: <span className="inline-text-tag inline-text-tag--light-half">{ option.value }</span>
                    </li>
                  )
                }
                <li><strong>Unit Cost</strong>: <span className="inline-text-tag">{ purchaseOrderLine.supplier_price ? format(purchaseOrderLine.supplier_price) : "Price not set" }</span></li>
                { settings?.settings?.pack_quantities && purchaseOrderLine.packQuantity &&
                  <li>
                    <strong>Pack Quantity</strong>:
                    <span className="inline-text-tag">{ purchaseOrderLine.packQuantity }</span>
                  </li>
                }
              </ul>
            </div>

            <div className="flex-1">
              <div className="left-15">

                <div className="fieldset">
                  <div className="field field--medium field--filled">
                    <span className="fieldset__svg-icon"></span>
                    <label className="field__label">Quantity</label>
                    <input 
                      id="quantity" 
                      type="number"
                      min="0"
                      value={ quantity } 
                      onChange={(e) => updateQuantity(e)}
                      className="field__input"
                      onFocus={focus}
                      onBlur={blur}
                    />
                    <div className="field__placeholder">Quantity</div>
                    <span className="field-state--success"><svg xmlns="http://www.w3.org/2000/svg" width="26px" height="26px" viewBox="0 0 26 26" focusable="false"><path d="M5 12l5.02 4.9L21.15 4c.65-.66 1.71-.66 2.36 0 .65.67.65 1.74 0 2.4l-12.3 14.1c-.33.33-.76.5-1.18.5-.43 0-.86-.17-1.18-.5l-6.21-6.1c-.65-.66-.65-1.74 0-2.41.65-.65 1.71-.65 2.36.01z"></path></svg></span>
                    <span className="field-state--close"><svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 16 16" enable-background="new 0 0 16 16" xml:space="preserve" focusable="false"><path d="M15.6,15.5c-0.53,0.53-1.38,0.53-1.91,0L8.05,9.87L2.31,15.6c-0.53,0.53-1.38,0.53-1.91,0c-0.53-0.53-0.53-1.38,0-1.9l5.65-5.64L0.4,2.4c-0.53-0.53-0.53-1.38,0-1.91c0.53-0.53,1.38-0.53,1.91,0l5.64,5.63l5.74-5.73c0.53-0.53,1.38-0.53,1.91,0c0.53,0.53,0.53,1.38,0,1.91L9.94,7.94l5.66,5.65C16.12,14.12,16.12,14.97,15.6,15.5z"></path></svg></span>
                  </div>
                  <div className="field__error" aria-hidden="true" style={{ display: 'none' }}></div>
                </div>

                <br/>
                <br/>
                
                <div className="fieldset">
                  <div className="field field--medium field--filled">
                    <span className="fieldset__svg-icon"></span>
                    <label className="field__label">Adjusted Unit Cost</label>
                    <input
                      id="adjusted_unit_cost" 
                      type="number"
                      min="0"
                      value={ adjustedUnitCost || purchaseOrderLine.supplier_price }
                      onChange={(e) => overrideUnitCost(e)}
                      className="field__input"
                      onFocus={focus}
                      onBlur={blur}
                    />
                    <div className="field__placeholder">Adjusted Unit Cost</div>
                    <span className="field-state--success"><svg xmlns="http://www.w3.org/2000/svg" width="26px" height="26px" viewBox="0 0 26 26" focusable="false"><path d="M5 12l5.02 4.9L21.15 4c.65-.66 1.71-.66 2.36 0 .65.67.65 1.74 0 2.4l-12.3 14.1c-.33.33-.76.5-1.18.5-.43 0-.86-.17-1.18-.5l-6.21-6.1c-.65-.66-.65-1.74 0-2.41.65-.65 1.71-.65 2.36.01z"></path></svg></span>
                    <span className="field-state--close"><svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 16 16" enable-background="new 0 0 16 16" xml:space="preserve" focusable="false"><path d="M15.6,15.5c-0.53,0.53-1.38,0.53-1.91,0L8.05,9.87L2.31,15.6c-0.53,0.53-1.38,0.53-1.91,0c-0.53-0.53-0.53-1.38,0-1.9l5.65-5.64L0.4,2.4c-0.53-0.53-0.53-1.38,0-1.91c0.53-0.53,1.38-0.53,1.91,0l5.64,5.63l5.74-5.73c0.53-0.53,1.38-0.53,1.91,0c0.53,0.53,0.53,1.38,0,1.91L9.94,7.94l5.66,5.65C16.12,14.12,16.12,14.97,15.6,15.5z"></path></svg></span>
                  </div>
                  <div className="field__error" aria-hidden="true" style={{ display: 'none' }}></div>
                </div>


                <br/>
                <br/>
                

                <div className="flex-container">
                  <strong>Subtotal:</strong>
                  <div>{ format((adjustedUnitCost || purchaseOrderLine.supplier_price) * quantity) }</div>
                </div>

                { (parseInt(purchaseOrderLine.minimumOrder) > quantity) &&
                    <div className="text-small warning">
                      Quantity below MOQ: { purchaseOrderLine.minimumOrder }
                    </div>
                }

                { settings?.settings?.order_multiples && purchaseOrderLine.orderMultiple && (quantity % purchaseOrderLine.orderMultiple !== 0) &&
                    <div className="text-small warning">
                      Quantity not divisible by order multiple: { purchaseOrderLine.orderMultiple } ({ quantity % purchaseOrderLine.orderMultiple })
                    </div>
                }

                { purchaseOrderType === 'direct' && settings?.settings?.pack_quantities && (parseInt(purchaseOrderLine.packQuantity) > 1) &&
                    <div className="text-small warning">
                      Can't fulfill direct orders with pack quantities higher than 1.
                    </div>
                }

              </div>
            </div>

            <div className="flex-1">
              <div className="left-15">

                <div className="fieldset">
                  <div className="field field--medium field--filled">
                    <span className="fieldset__svg-icon"></span>
                    <label className="field__label">Adjusted Tax Cost</label>
                    <input 
                      id="adjusted_unit_cost" 
                      type="number"
                      min="0"
                      value={ adjustedTax }
                      onChange={(e) => overrideUnitTax(e)}
                      className="field__input"
                      onFocus={focus}
                      onBlur={blur}
                      />
                    <div className="field__placeholder">Adjusted Tax Cost</div>
                    <span className="field-state--success"><svg xmlns="http://www.w3.org/2000/svg" width="26px" height="26px" viewBox="0 0 26 26" focusable="false"><path d="M5 12l5.02 4.9L21.15 4c.65-.66 1.71-.66 2.36 0 .65.67.65 1.74 0 2.4l-12.3 14.1c-.33.33-.76.5-1.18.5-.43 0-.86-.17-1.18-.5l-6.21-6.1c-.65-.66-.65-1.74 0-2.41.65-.65 1.71-.65 2.36.01z"></path></svg></span>
                    <span className="field-state--close"><svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 16 16" enable-background="new 0 0 16 16" xml:space="preserve" focusable="false"><path d="M15.6,15.5c-0.53,0.53-1.38,0.53-1.91,0L8.05,9.87L2.31,15.6c-0.53,0.53-1.38,0.53-1.91,0c-0.53-0.53-0.53-1.38,0-1.9l5.65-5.64L0.4,2.4c-0.53-0.53-0.53-1.38,0-1.91c0.53-0.53,1.38-0.53,1.91,0l5.64,5.63l5.74-5.73c0.53-0.53,1.38-0.53,1.91,0c0.53,0.53,0.53,1.38,0,1.91L9.94,7.94l5.66,5.65C16.12,14.12,16.12,14.97,15.6,15.5z"></path></svg></span>
                  </div>
                  <div className="field__error" aria-hidden="true" style={{ display: 'none' }}></div>
                </div>
                
              </div>
            </div>

            <div className="flex-1">
              { activeSupplier && purchaseOrderType === 'direct' && purchaseOrderLine.orderMatchingAssignment &&
                <div className="left-15 text-small muted">
                  Supplier Assigned
                </div>
              }
              { activeSupplier && purchaseOrderType === 'direct' && !purchaseOrderLine.orderMatchingAssignment && ( !(parseInt(purchaseOrderLine.packQuantity) > 1) || !settings?.settings?.pack_quantities )&&
                <>
                  <div className="left-15 text-small error">
                    Supplier Not Assigned
                  </div>
                  <button
                    className="btn btn-link"
                    onClick={(e) => showAddSupplierAssignmentModal(e)}
                  >
                    <span className="svg-icon">
                      <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18"><path d="M9.9968 8.0396h6.0302c.5374 0 .973.4356.973.973s-.4356.973-.973.973H9.9968V16c0 .5523-.4477 1-1 1h-.023c-.5523 0-1-.4477-1-1V9.9884H1.9744C1.4363 9.9884 1 9.5521 1 9.014s.4363-.9744.9744-.9744h5.9994V2c0-.5523.4477-1 1-1h.0244c.5523 0 1 .4477 1 1v6.0396h-.0014z"/></svg>
                    </span>
                    <span className="gwt-InlineLabel">Add supplier assignment</span>
                  </button>
                </>
              }

              { activeSupplier && purchaseOrderType === 'direct' && <br/> }

              <div className="left-15">
                <button
                  className="btn btn-default btn--destructive"
                  onClick={() => remove(purchaseOrderLine.productId + '/' + purchaseOrderLine.variationId)}
                >
                  <span className="svg-icon">
                    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18"><path d="M7 0h4l1 2H6l1-2z"/><path fill-rule="evenodd" clip-rule="evenodd" d="M2 3c-.5523 0-1 .4477-1 1s.4477 1 1 1v11c0 1.1046.8954 2 2 2h10c1.1046 0 2-.8954 2-2V5c.5523 0 1-.4477 1-1s-.4477-1-1-1H2zm12 13V5H4v11h10z"/><path d="M6 7.5c0-.5523.4477-1 1-1s1 .4477 1 1v6c0 .5523-.4477 1-1 1s-1-.4477-1-1v-6zM10 7.5c0-.5523.4477-1 1-1s1 .4477 1 1v6c0 .5523-.4477 1-1 1s-1-.4477-1-1v-6z"/></svg>
                  </span>
                  <span className="gwt-InlineLabel">Remove</span>
                </button>
              </div>
              
            </div>
          </div>
        </div>
      </div>
    </div>
  )

}

const mapStateToProps = state => ({
  accountUnits: state.accounts.account.store_details.formatsAndUnits,
  purchaseOrderLines: state.purchaseOrderLines,
  activeSuggestedPurchaseOrder: state.suggestedPurchaseOrders.activeSuggestedPurchaseOrder,
  settings: state.settings,
});

const mapDispatchToProps = (dispatch) => ({
  quantityUpdate: (payload, itemData, itemKey) => dispatch(purchaseOrderUpdateQuantity(payload, itemData, itemKey)),
  overrideCost: (payload, itemData, itemKey) => dispatch(purchaseOrderOverrideUnitCost(payload, itemData, itemKey)),
  overrideTax: (payload, itemData, itemKey) => dispatch(purchaseOrderOverrideLineTax(payload, itemData, itemKey)),
  remove: (itemKey) => dispatch(removeOrderLine(itemKey)),
});

export default connect(mapStateToProps, mapDispatchToProps)(PurchaseOrderLine);